var _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPocketPathologistIconMicroscopeTransparent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    enableBackground: "new 0 0 700 700",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ECADCE",
    d: "M575.81,532.47v18.02c0,12.79-10.37,23.16-23.16,23.16h-33.2c0,0-0.02,0-0.04,0H154.33 c-12.79,0-23.16-10.37-23.16-23.16v-18.02c0-7.21,1.81-14,5-19.93c7.11-13.25,21.1-22.26,37.19-22.26h360.24 C556.91,490.27,575.81,509.16,575.81,532.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#98D0D7",
    strokeWidth: 37.9675,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M284.53,250.45H434.8c52.3,0,94.69,42.4,94.69,94.69v1.54c0,52.3-42.4,94.69-94.69,94.69H182.63"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDABD3",
    d: "M500.15,490.27H370.47v-75.82c0-12.13,9.84-21.96,21.96-21.96h62.34c9.72,0,18.29,6.4,21.06,15.72 L500.15,490.27z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C0E1E6",
    strokeWidth: 41.3317,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 348.7,
    y1: 127.26,
    x2: 234.12,
    y2: 367.56
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#C0E1E6",
    strokeWidth: 27.3942,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 330.1,
    y1: 109.41,
    x2: 375.99,
    y2: 131.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDABD3",
    d: "M371.74,204.05l-67.89,142.37c-4.76,9.99-15.08,15.53-25.48,14.69c-3.07-0.25-6.14-1.05-9.08-2.45 l-49.32-23.52c-12.93-6.17-18.41-21.64-12.24-34.56l67.89-142.37c3.82-8.01,11.23-13.16,19.38-14.45 c4.99-0.79,10.27-0.13,15.18,2.21l49.32,23.52C372.42,175.66,377.9,191.13,371.74,204.05z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E068A7",
    d: "M519.45,573.64c0,0-0.02,0-0.04,0H154.33c-12.79,0-23.16-10.37-23.16-23.16v-18.02c0-7.21,1.81-14,5-19.93 c1.63,10.45,8.66,22.36,29.17,30.46C209.31,560.38,519.45,573.47,519.45,573.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9076B6",
    d: "M494.71,490.27H370.47v-71.32c4.71,16.44,13.82,40.85,28,49.42C420.6,481.76,494.71,490.27,494.71,490.27z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9076B6",
    d: "M278.37,361.12c-3.07-0.25-6.14-1.05-9.08-2.45l-49.32-23.52c-12.93-6.17-18.41-21.64-12.24-34.56 l67.89-142.37c3.82-8.01,11.23-13.16,19.38-14.45c-17.92,31.5-62.81,114.49-60.88,152.21C235.82,329.06,262.6,351,278.37,361.12z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x34_"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_x36_"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocketPathologistIconMicroscopeTransparent);
export default __webpack_public_path__ + "static/media/Pocket Pathologist-Icon_Microscope-transparent.799811a3a02cbf8872c624a064ba355b.svg";
export { ForwardRef as ReactComponent };